import { render, staticRenderFns } from "./blocks2.vue?vue&type=template&id=3daf819e&"
import script from "./blocks2.vue?vue&type=script&lang=js&"
export * from "./blocks2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports